import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import App from "./App.tsx";
import "./index.css";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000, // 5 minutes
			retry: (failureCount, error: any) => {
				// Don't retry on 4xx errors
				if (error?.status >= 400 && error?.status < 500) {
					return false;
				}
				return failureCount < 3;
			},
		},
	},
});

ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<BrowserRouter>
			<QueryClientProvider client={queryClient}>
				<App />
				<Toaster
					position="top-right"
					toastOptions={{
						style: {
							background: "hsl(var(--background))",
							color: "hsl(var(--foreground))",
							border: "1px solid hsl(var(--border))",
						},
					}}
				/>
			</QueryClientProvider>
		</BrowserRouter>
	</React.StrictMode>,
);
